import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SecuritySection = ({ securitySettings, onUpdateSecurity }) => {
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [errors, setErrors] = useState({});

  const handlePasswordChange = async () => {
    setErrors({});
    
    if (passwordForm?.newPassword !== passwordForm?.confirmPassword) {
      setErrors({ confirmPassword: 'Passwords do not match' });
      return;
    }

    if (passwordForm?.newPassword?.length < 8) {
      setErrors({ newPassword: 'Password must be at least 8 characters long' });
      return;
    }

    setIsChangingPassword(true);
    try {
      await onUpdateSecurity({
        type: 'password',
        currentPassword: passwordForm?.currentPassword,
        newPassword: passwordForm?.newPassword
      });
      setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setShowPasswordForm(false);
    } catch (error) {
      setErrors({ currentPassword: 'Current password is incorrect' });
    } finally {
      setIsChangingPassword(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Password Section */}
      <div className="bg-card rounded-organic border border-border p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-secondary rounded-full flex items-center justify-center">
              <Icon name="Lock" size={20} color="white" />
            </div>
            <div>
              <h3 className="font-heading font-heading-bold text-lg text-card-foreground">Password</h3>
              <p className="font-caption text-sm text-muted-foreground">Change your account password</p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowPasswordForm(!showPasswordForm)}
          >
            {showPasswordForm ? 'Cancel' : 'Change Password'}
          </Button>
        </div>

        {showPasswordForm && (
          <div className="space-y-4 pt-4 border-t border-border">
            <Input
              label="Current Password"
              type="password"
              value={passwordForm?.currentPassword}
              onChange={(e) => setPasswordForm(prev => ({ ...prev, currentPassword: e?.target?.value }))}
              error={errors?.currentPassword}
              required
            />
            <Input
              label="New Password"
              type="password"
              value={passwordForm?.newPassword}
              onChange={(e) => setPasswordForm(prev => ({ ...prev, newPassword: e?.target?.value }))}
              error={errors?.newPassword}
              description="Must be at least 8 characters long"
              required
            />
            <Input
              label="Confirm New Password"
              type="password"
              value={passwordForm?.confirmPassword}
              onChange={(e) => setPasswordForm(prev => ({ ...prev, confirmPassword: e?.target?.value }))}
              error={errors?.confirmPassword}
              required
            />
            <div className="flex items-center justify-end space-x-3 pt-2">
              <Button
                variant="outline"
                onClick={() => {
                  setShowPasswordForm(false);
                  setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
                  setErrors({});
                }}
              >
                Cancel
              </Button>
              <Button
                variant="default"
                onClick={handlePasswordChange}
                loading={isChangingPassword}
                disabled={!passwordForm?.currentPassword || !passwordForm?.newPassword || !passwordForm?.confirmPassword}
              >
                Update Password
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SecuritySection;